import { commonRunQuery } from "./API/loans";

const asArray = (value) => (Array.isArray(value) ? value : value ? [value] : []);

/**
 * Validates an entered payroll account number against the active account list.
 * Query 385 is deliberately limited to existence/uniqueness: it does not
 * restore the retired phone/email contact-matching checks (queries 384/385).
 */
export const validatePayrollAccountNumber = async (value) => {
  const accountNumber = String(value ?? "").trim();

  // Use the service's zero sentinel for a missing account, never an unfiltered lookup.
  let response;
  try {
    response = await commonRunQuery(385, accountNumber || "0");
  } catch {
    response = null;
  }
  if (!/^\d+$/.test(accountNumber) || /^0+$/.test(accountNumber)) {
    return { isValid: false, message: "Enter a non-zero numeric account number." };
  }

  if (String(response?.data?.header?.callStatus) !== "1") {
    return {
      isValid: false,
      message: "Could not validate the account number. Please try again.",
    };
  }

  const responseRecord = response?.data?.body?.record;
  const rawRecords =
    responseRecord?.b ??
    responseRecord?.dir ??
    responseRecord?.record ??
    responseRecord;
  const records = asArray(rawRecords).filter(
    (row) => row && typeof row === "object" && Object.keys(row).length > 0,
  );

  if (records.length === 0) {
    return {
      isValid: false,
      message: `Account number "${accountNumber}" was not found in the active account records.`,
    };
  }

  if (records.length > 1) {
    return {
      isValid: false,
      message:
        "This account number is linked to multiple active accounts. Please contact support.",
    };
  }

  return { isValid: true };
};
